import { render, staticRenderFns } from "./CategoryCoursePackage.vue?vue&type=template&id=24a3185c&"
import script from "./CategoryCoursePackage.vue?vue&type=script&lang=js&"
export * from "./CategoryCoursePackage.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCoursePackage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports